import { useTranslation } from 'react-i18next';
import { Headline, HtmlContainer, Paragraph } from '../../ui';
import { useApplicationIdContext } from '@n2-common/components/ApplicationContext';
type ErrorPageProps = { headline?: string; subheadline?: string; body?: string };
const ErrorPage = (props: ErrorPageProps): JSX.Element => {
    const { applicationId } = useApplicationIdContext(false, false);
    const { t } = useTranslation('common');
    const {
        headline = t<string>('ApplicationLandingPages.Error.Headline'),
        subheadline = t<string>('ApplicationLandingPages.Error.SubHeadline'),
        body = t<string>('ApplicationLandingPages.Error.Body', ''),
    } = props;
    return (
        <>
            <Headline level={1}> {headline}</Headline>
            <Headline level={2}>{subheadline}</Headline>
            {body && <HtmlContainer innerHtml={body} />}
            <ReloadLink applicationId={applicationId} />
        </>
    );
};

function ReloadLink({ applicationId }: { applicationId?: string }) {
    const { t } = useTranslation('common');
    const onClick = () => {
        location.replace(`${location.pathname}?applicationId?${applicationId}`);
    };

    return applicationId ? (
        <Paragraph>
            <br />
            <br />
            <a href="#" onClick={onClick}>
                {'< '} {t('Navigation.Back')}
            </a>
        </Paragraph>
    ) : null;
}

export default ErrorPage;
